import { z } from 'zod'

export const becomePartnerSchema = z.object({
  name: z
    .string({ required_error: 'O nome da instituição é obrigatório.' })
    .trim()
    .min(1, 'O nome da instituição é obrigatório.'),
  email: z
    .string({ required_error: 'O e-mail é obrigatório.' })
    .trim()
    .email({ message: 'E-mail inválido.' }),
  phone: z
    .string({ required_error: 'O telefone é obrigatório.' })
    .trim()
    .min(15, {
      message: 'O telefone precisa ter, no mínimo, 11 números.',
    }),
  termsOfUse: z
    .boolean({
      required_error: 'Você precisa aceitar os termos de uso.',
    })
    .refine((value) => value === true, {
      message: 'Você precisa aceitar os termos de uso.',
    }),
})
